import React from 'react'
import { async, Widget } from 'widgets-for-react'
import { any, fromJSX, Updater } from 'widgets-for-react'
import { blocksWidget } from '../../blocks/blocksWidget'
import { cmsPageStateUpdaters, Link, Page, SpaarnePage } from '../../cmsPageState'
import { SpaarnePageHeader } from './spaarnePageLayout'
import { spaarneBreadcrumbs } from '../../../../utils/breadcrumbs'

export const spaarnePageWidget =
  (acceptVideoCookie: () => void) =>
  (page: SpaarnePage): Widget<Updater<Page>> => {
    const blocks = blocksWidget(acceptVideoCookie)(page.blocks).map((updater) =>
      cmsPageStateUpdaters.blocksUpdater(updater)
    )

    const parent = page.parent
    const grandParent = page.parent?.kind === 'spaarne' ? page.parent.parent : undefined
    const breadcrumbs = spaarneBreadcrumbs(page)
    return parent === undefined
      ? any([
          async<Link[]>(page.childrenState).map(cmsPageStateUpdaters.pageTreeStateUpdater),
          fromJSX((setState) => (
            <SpaarnePageHeader
              title={page.title}
              intro={page.intro}
              image={page.image}
              link={page.link}
              menuItems={
                page.childrenState.kind === 'loaded'
                  ? [
                      { title: page.title, url: page.url, active: true },
                      ...page.childrenState.value.map((child) => ({ ...child, active: false })),
                    ]
                  : undefined
              }
              menuOpened={page.menuOpened}
              toggleMenu={() => setState(cmsPageStateUpdaters.menuOpenedUpdater)}
              breadcrumbs={breadcrumbs}
              contactItems={[]}
            />
          )),
          blocks,
        ])
      : parent.kind === 'spaarne'
      ? grandParent === undefined
        ? any([
            async<Link[]>(page.childrenState).map(cmsPageStateUpdaters.pageTreeStateUpdater),
            fromJSX((setState) => (
              <SpaarnePageHeader
                title={page.title}
                intro={page.intro}
                image={page.image}
                link={page.link}
                menuItems={
                  page.childrenState.kind === 'loaded'
                    ? [
                        { title: parent.title, url: parent.url, active: false },
                        ...page.childrenState.value.map((child) => ({
                          ...child,
                          active: child.url === page.url,
                        })),
                      ]
                    : undefined
                }
                menuOpened={page.menuOpened}
                toggleMenu={() => setState(cmsPageStateUpdaters.menuOpenedUpdater)}
                breadcrumbs={breadcrumbs}
                contactItems={[]}
              />
            )),
            blocks,
          ])
        : grandParent.kind === 'centrum'
        ? any([
            async<Link[]>(page.childrenState).map(cmsPageStateUpdaters.pageTreeStateUpdater),
            fromJSX(() => (
              <SpaarnePageHeader
                centrum={grandParent.centrum ? { title: grandParent.centrum?.title, url: grandParent.url } : undefined}
                title={page.title}
                intro={page.intro}
                image={page.image}
                link={page.link}
                contactItems={grandParent.centrum?.contactItems || []}
                appointmentUrl={grandParent.centrum?.appointmentUrl || undefined}
                menuItems={
                  page.childrenState.kind == 'loaded'
                    ? [
                        { title: grandParent.title, url: grandParent.url, active: false },
                        ...page.childrenState.value.map((child) => ({
                          ...child,
                          active: child.url === parent.url,
                        })),
                      ]
                    : undefined
                }
                breadcrumbs={breadcrumbs}
              />
            )),
            blocks,
          ])
        : any([
            async<Link[]>(page.childrenState).map(cmsPageStateUpdaters.pageTreeStateUpdater),
            fromJSX((setState) => (
              <SpaarnePageHeader
                title={page.title}
                intro={page.intro}
                image={page.image}
                link={page.link}
                menuItems={
                  page.childrenState.kind == 'loaded'
                    ? [
                        { title: grandParent.title, url: grandParent.url, active: false },
                        ...page.childrenState.value.map((child) => ({
                          ...child,
                          active: child.url === parent.url,
                        })),
                      ]
                    : undefined
                }
                menuOpened={page.menuOpened}
                toggleMenu={() => setState(cmsPageStateUpdaters.menuOpenedUpdater)}
                breadcrumbs={breadcrumbs}
                contactItems={[]}
              />
            )),
            blocks,
          ])
      : any([
          async<Link[]>(page.childrenState).map(cmsPageStateUpdaters.pageTreeStateUpdater),
          fromJSX(() => (
            <SpaarnePageHeader
              centrum={parent.centrum ? { title: parent.centrum.title, url: parent.url } : undefined}
              title={page.title}
              intro={page.intro}
              image={page.image}
              link={page.link}
              contactItems={parent.centrum?.contactItems || []}
              appointmentUrl={parent.centrum?.appointmentUrl || undefined}
              menuItems={
                page.childrenState.kind === 'loaded'
                  ? [
                      { title: parent.title, url: parent.url, active: false },
                      ...page.childrenState.value.map((child) => ({ ...child, active: child.url === page.url })),
                    ]
                  : undefined
              }
              breadcrumbs={breadcrumbs}
            />
          )),
          blocks,
        ])
  }
